import React from 'react';
import {
  SelectField,
  MenuItem,
  FlatButton,
  Dialog,
} from 'material-ui';

import { isDev } from '../../utils/permissionsUtils';

const style = {
  padding: '0 15px 15px 15px',
};

class ExportComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      language: '',
    };
  }

  onLanguageChange = (event, index, value) => {
    this.setState({ language: value });
    this.props.onLanguageChangeCb(value);
    document.querySelector('#fileInput').value = null;
  };

  onAccept = () => {
    this.setState({ open: false });
    if (this.state.actionType === 'import') {
      this.props.importFn(this.state.language, this.props.platform);
    } else {
      this.props.exportFn(this.state.language);
    }
    document.querySelector('#fileInput').value = null;
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  handleOpen = () => {
    this.setState({ open: true });
  }

  handleAction = (type) => {
    this.setState({ actionType: type, open: true });
  }

  render() {
    const {
      platform,
      disabled,
      translate,
      fileName,
      handleUpload,
      user,
    } = this.props;
    const {
      actionType,
      language,
      open,
    } = this.state;

    const actions = [
      <FlatButton label={translate('cancel')} primary onClick={this.handleClose} />,
      <FlatButton label={translate('OK')} primary onClick={this.onAccept} />,
    ];
    return (
      <div style={style}>
        <div>
          <SelectField
            floatingLabelText={translate('choose.item', { item: translate('language') })}
            value={language}
            onChange={this.onLanguageChange}
          >
            <MenuItem value="en" primaryText="English" />
            <MenuItem value="sv" primaryText="Swedish" />
            <MenuItem value="nb" primaryText="Norwegian" />
            <MenuItem value="da" primaryText="Danish" />
            <MenuItem value="fi" primaryText="Finnish" />
            <MenuItem value="de" primaryText="German" />
            <MenuItem value="es" primaryText="Spanish" />
          </SelectField>
        </div>

        <div>
          <FlatButton primary disabled={!language} onClick={() => this.handleAction('export') /* exportFn(language) */}>Export</FlatButton>
          {
            isDev(user) && (
              <FlatButton primary disabled={disabled} onClick={() => this.handleAction('import') /* importFn(language, platform) */}>Import</FlatButton>
            )
          }

        </div>

        <div style={{ display: 'flex' }}>
          <FlatButton
            label={translate('choose.item', { item: translate('file') })}
            labelPosition="before"
            containerElement="label"
            primary
            disabled={!language}
          >
            <input
              style={{
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                width: '100%',
                opacity: 0,
              }}
              type="file"
              id="fileInput"
              disabled={!language}
              onChange={(e) => handleUpload(e, platform)}
            />
          </FlatButton>
          <span style={{ marginLeft: '10px', lineHeight: '36px' }}>{fileName}</span>
        </div>
        <ConfirmDialog
          actions={actions}
          open={open}
          fileName={fileName}
          actionType={actionType}
          language={language}
          translate={translate}
        />
      </div>
    );
  }
}

const ConfirmDialog = ({ actions, open = false, fileName, actionType, language, translate }) => (
  <div>
    <Dialog
      title={actionType ? `Confirm ${translate(actionType)}` : ''}
      actions={actions}
      open={open}
      modal
    >
      { actionType === 'import'
        ? <span>This will <strong>{actionType}</strong> file: <strong>{fileName}</strong> in language: <strong>{translate(`languages.${language}`)}</strong></span>
        : <span>This will <strong>{actionType}</strong> all translations in language: <strong>{translate(`languages.${language}`)}</strong></span>
      }
    </Dialog>
  </div>
);

export default ExportComponent;
